/* eslint-disable no-new */
import { initBadges } from "components/jiffy/j1-badge/j1-badge-popup/j1-badge-popup";
import initSoftnessScore from "components/compositions/softness_score/component";
import initProductsPrimaryMaterialFilter from "components/jiffy/products-primary-material-filter/products-primary-material-filter";
import { ProductFilterLinkClass } from "../products-filter-link-class";
import { ProductsFilterModalWrapperVisibilityClass } from "./products-filter-modal-wrapper-visibility-class";
import { ProductsFilterModalLoader } from "./products-filter-modal-loader";
import { ProductsFilterModalSubmitClass } from "./products-filter-modal-submit-class";

export default () => {
  if (!document.querySelector(".js-products-filter-modal-wrapper")) return;

  const links = new ProductFilterLinkClass({
    eventSelector: ".js-products-filter-mobile .js-products-filter-link",
    eventCallback: () => {
      // eslint-disable-next-line no-use-before-define
      submitButton.enableButtons();
    }
  });

  const filtersLoader = new ProductsFilterModalLoader({
    filtersWrapperSelector: ".js-masthead-mobile-filters-content",
    filtersLoaderSelector: ".js-masthead-mobile-filters-loader",
    loadingCallback: () => {
      initBadges();
      initSoftnessScore();
      initProductsPrimaryMaterialFilter();
    }
  });

  new ProductsFilterModalWrapperVisibilityClass({
    eventSelector: ".js-masthead-search-filter, .js-masthead-mobile-filters-toggler",
    modalSelector: ".js-products-filter-modal-wrapper",
    eventCallback: () => {
      filtersLoader.getFilters();
    }
  });

  const submitButton = new ProductsFilterModalSubmitClass({
    eventSelector: ".js-masthead-mobile-filters-submit",
    eventCallback: () => {
      links.manualSubmit();
    }
  });

  filtersLoader.autoLoadingMobileFilters();
};
